/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Geos object, a collection of MCity/MNeighborhood
 */

import { Bizo, autoclass } from '../../shared/bizos/base'
import { MCity, scrub as scrubCity } from '../../shared/bizos/city'
import { MNeighborhood, scrub as scrubNeighborhood } from '../../shared/bizos/neighborhood'

const scrubValue = (value, scrubber) =>
  Array.isArray(value) ? value.map(scrubber) : scrubber(value)

// scrub unimportant data
const scrub = (data) => {
  if (!data) {
    return data
  }
  const scrubbedData = { ...data }
  for (const cityKey of [
    'cities',
    'nearby_cities',
    'nearby_military_bases',
    'nearby_universities',
  ]) {
    if (scrubbedData[cityKey] !== undefined) {
      scrubbedData[cityKey] = scrubValue(scrubbedData[cityKey], scrubCity)
    }
  }
  for (const hoodKey of ['hood', 'nearby_hoods', 'nearby_zipcodes', 'zipcode']) {
    if (scrubbedData[hoodKey] !== undefined) {
      scrubbedData[hoodKey] = scrubValue(scrubbedData[hoodKey], scrubNeighborhood)
    }
  }
  return scrubbedData
}

const Geos = autoclass(
  'Geos',
  class Geos extends Bizo {
    constructor(data = {}) {
      super(data)
      this._data = scrub(data)
    }
  },
  {
    cities: { name: 'cities', type: MCity, isArray: true },
    hood: { name: 'hood', type: MNeighborhood },
    nearbyCities: { name: 'nearby_cities', type: MCity, isArray: true },
    nearbyHoods: { name: 'nearby_hoods', type: MNeighborhood, isArray: true },
    nearbyMilitaryBases: { name: 'nearby_military_bases', type: MCity, isArray: true },
    nearbyUniversities: { name: 'nearby_universities', type: MCity, isArray: true },
    nearbyZipcodes: { name: 'nearby_zipcodes', type: MNeighborhood, isArray: true },
    zipcode: { name: 'zipcode', type: MNeighborhood },
    // NOTE: this is not always a correct assumption. The first city in the list
    // is nearest to the coordinates we sent to the API... but those coordinates
    // are chomped when we use Geos.locate and might not line up with the actual
    // map center. This can lead to cases where (in crowded metro areas) the
    // city we actually want is second or third in the list.
    city: (t) => (t.cities && t.cities.length > 0 ? t.cities[0] : undefined),
    stateName: (t) =>
      (t.cities && t.cities[0] && t.cities[0].state) ||
      (t.nearbyCities && t.nearbyCities[0] && t.nearbyCities[0].state) ||
      undefined,
    encodedBounds: (t) =>
      (t.cities && t.cities.length > 0 && t.cities[0]._data.encoded_bounds) ||
      (t.hood && t.hood._data.encoded_bounds) ||
      undefined,
  }
)
export default Geos
